import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45a3c11a")

_pushScopeId("data-v-45a3c11a")
const _hoisted_1 = {
  novalidate: "",
  id: "providerNotificationsRestrictionsForm"
}
const _hoisted_2 = {
  class: "accordion",
  id: "accordionProviderNotifications"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  class: "default-card-header white-card-header collapsed",
  id: "headingBasicNotification",
  "data-toggle": "collapse",
  "data-target": "#providerBasicNotification"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerBasicNotification"
}
const _hoisted_7 = { class: "status-title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "status-green"
}
const _hoisted_10 = {
  key: 1,
  class: "status-red"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "arrow gray float-right" }, null, -1)
const _hoisted_12 = {
  id: "providerBasicNotification",
  class: "collapse",
  "aria-labelledby": "headingBasicNotification",
  "data-parent": "#accordionProviderNotifications"
}
const _hoisted_13 = { class: "card-body default-card-body" }
const _hoisted_14 = { class: "several-section" }
const _hoisted_15 = { class: "sub-notification-block" }
const _hoisted_16 = { class: "status-title" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "status-green"
}
const _hoisted_19 = {
  key: 1,
  class: "status-red"
}
const _hoisted_20 = { class: "sub-notification-block" }
const _hoisted_21 = { class: "status-title" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "status-green"
}
const _hoisted_24 = {
  key: 1,
  class: "status-red"
}
const _hoisted_25 = { class: "sub-notification-block" }
const _hoisted_26 = { class: "status-title" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "status-green"
}
const _hoisted_29 = {
  key: 1,
  class: "status-red"
}
const _hoisted_30 = { class: "sub-notification-block" }
const _hoisted_31 = { class: "status-title" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "status-green"
}
const _hoisted_34 = {
  key: 1,
  class: "status-red"
}
const _hoisted_35 = { class: "sub-notification-block" }
const _hoisted_36 = { class: "status-title" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "status-green"
}
const _hoisted_39 = {
  key: 1,
  class: "status-red"
}
const _hoisted_40 = { class: "sub-notification-block" }
const _hoisted_41 = { class: "status-title" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "status-green"
}
const _hoisted_44 = {
  key: 1,
  class: "status-red"
}
const _hoisted_45 = { class: "sub-notification-block" }
const _hoisted_46 = { class: "status-title" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 0,
  class: "status-green"
}
const _hoisted_49 = {
  key: 1,
  class: "status-red"
}
const _hoisted_50 = { class: "sub-notification-block" }
const _hoisted_51 = { class: "status-title" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 0,
  class: "status-green"
}
const _hoisted_54 = {
  key: 1,
  class: "status-red"
}
const _hoisted_55 = { class: "sub-notification-block" }
const _hoisted_56 = { class: "status-title" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  key: 0,
  class: "status-green"
}
const _hoisted_59 = {
  key: 1,
  class: "status-red"
}
const _hoisted_60 = { class: "card" }
const _hoisted_61 = {
  class: "default-card-header white-card-header collapsed",
  id: "headingBasicNotification",
  "data-toggle": "collapse",
  "data-target": "#providerUnfinishedProductsNotification"
}
const _hoisted_62 = { class: "mb-0" }
const _hoisted_63 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerUnfinishedProductsNotification"
}
const _hoisted_64 = { class: "status-title" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  key: 0,
  class: "status-green"
}
const _hoisted_67 = {
  key: 1,
  class: "status-red"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "arrow gray float-right" }, null, -1)
const _hoisted_69 = {
  id: "providerUnfinishedProductsNotification",
  class: "collapse",
  "aria-labelledby": "headingBasicNotification",
  "data-parent": "#accordionProviderNotifications"
}
const _hoisted_70 = { class: "card-body default-card-body" }
const _hoisted_71 = { class: "several-section" }
const _hoisted_72 = { class: "sub-notification-block" }
const _hoisted_73 = { class: "status-title" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  key: 0,
  class: "status-green"
}
const _hoisted_76 = {
  key: 1,
  class: "status-red"
}
const _hoisted_77 = { class: "sub-notification-block" }
const _hoisted_78 = { class: "status-title" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = {
  key: 0,
  class: "status-green"
}
const _hoisted_81 = {
  key: 1,
  class: "status-red"
}
const _hoisted_82 = { class: "sub-notification-block" }
const _hoisted_83 = { class: "status-title" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  key: 0,
  class: "status-green"
}
const _hoisted_86 = {
  key: 1,
  class: "status-red"
}
const _hoisted_87 = { class: "sub-notification-block" }
const _hoisted_88 = { class: "status-title" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = {
  key: 0,
  class: "status-green"
}
const _hoisted_91 = {
  key: 1,
  class: "status-red"
}
const _hoisted_92 = { class: "sub-notification-block" }
const _hoisted_93 = { class: "status-title" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = {
  key: 0,
  class: "status-green"
}
const _hoisted_96 = {
  key: 1,
  class: "status-red"
}
const _hoisted_97 = { class: "card" }
const _hoisted_98 = {
  class: "default-card-header white-card-header collapsed",
  id: "headingBasicNotification",
  "data-toggle": "collapse",
  "data-target": "#providerAboutUpcomingOrdersNotification"
}
const _hoisted_99 = { class: "mb-0" }
const _hoisted_100 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerAboutUpcomingOrdersNotification"
}
const _hoisted_101 = { class: "status-title" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = {
  key: 0,
  class: "status-green"
}
const _hoisted_104 = {
  key: 1,
  class: "status-red"
}
const _hoisted_105 = /*#__PURE__*/_createVNode("i", { class: "arrow gray float-right" }, null, -1)
const _hoisted_106 = {
  id: "providerAboutUpcomingOrdersNotification",
  class: "collapse",
  "aria-labelledby": "headingBasicNotification",
  "data-parent": "#accordionProviderNotifications"
}
const _hoisted_107 = { class: "card-body default-card-body" }
const _hoisted_108 = { class: "several-section" }
const _hoisted_109 = { class: "sub-notification-block" }
const _hoisted_110 = { class: "status-title" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = {
  key: 0,
  class: "status-green"
}
const _hoisted_113 = {
  key: 1,
  class: "status-red"
}
const _hoisted_114 = { class: "sub-notification-block" }
const _hoisted_115 = { class: "status-title" }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = {
  key: 0,
  class: "status-green"
}
const _hoisted_118 = {
  key: 1,
  class: "status-red"
}
const _hoisted_119 = { class: "card" }
const _hoisted_120 = {
  class: "default-card-header white-card-header collapsed",
  id: "headingBasicNotification",
  "data-toggle": "collapse",
  "data-target": "#providerProductBecameLiveNotification"
}
const _hoisted_121 = { class: "mb-0" }
const _hoisted_122 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerProductBecameLiveNotification"
}
const _hoisted_123 = { class: "status-title" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = {
  key: 0,
  class: "status-green"
}
const _hoisted_126 = {
  key: 1,
  class: "status-red"
}
const _hoisted_127 = /*#__PURE__*/_createVNode("i", { class: "arrow gray float-right" }, null, -1)
const _hoisted_128 = {
  id: "providerProductBecameLiveNotification",
  class: "collapse",
  "aria-labelledby": "headingBasicNotification",
  "data-parent": "#accordionProviderNotifications"
}
const _hoisted_129 = { class: "card-body default-card-body" }
const _hoisted_130 = { class: "several-section" }
const _hoisted_131 = { class: "sub-notification-block" }
const _hoisted_132 = { class: "status-title" }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = {
  key: 0,
  class: "status-green"
}
const _hoisted_135 = {
  key: 1,
  class: "status-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("form", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h5", _hoisted_5, [
            _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t('provider.notifications-restrictions.basic-notifications-group-title')), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.editMode === false)
              ? (_openBlock(), _createBlock("h5", _hoisted_8, [
                  (_ctx.basicNotificationsToggle)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('label.active')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('label.notactive')), 1))
                ]))
              : _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.activateDeactivateGroupNotifications(1, !_ctx.basicNotificationsToggle)), ["stop"])),
                  type: "checkbox",
                  class: "toggle",
                  checked: _ctx.basicNotificationsToggle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.basicNotificationsToggle = $event))
                }, null, 8, ["checked"])), [
                  [_vModelCheckbox, _ctx.basicNotificationsToggle]
                ])
          ]),
          _hoisted_11
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.order-created')), 1),
                _createVNode("div", _hoisted_16, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_17, [
                        (_ctx.notificationsRestrictions.orderCreated)
                          ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.orderCreated,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.notificationsRestrictions.orderCreated = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.orderCreated]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.order-confirmed')), 1),
                _createVNode("div", _hoisted_21, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_22, [
                        (_ctx.notificationsRestrictions.orderConfirmed)
                          ? (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.orderConfirmed,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.notificationsRestrictions.orderConfirmed = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.orderConfirmed]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.order-canceled')), 1),
                _createVNode("div", _hoisted_26, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_27, [
                        (_ctx.notificationsRestrictions.orderCanceled)
                          ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.orderCanceled,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.notificationsRestrictions.orderCanceled = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.orderCanceled]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.message-from-customer')), 1),
                _createVNode("div", _hoisted_31, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_32, [
                        (_ctx.notificationsRestrictions.newMessageFromCustomer)
                          ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.newMessageFromCustomer,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.notificationsRestrictions.newMessageFromCustomer = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.newMessageFromCustomer]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.message-from-user')), 1),
                _createVNode("div", _hoisted_36, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_37, [
                        (_ctx.notificationsRestrictions.newMessageFromUser)
                          ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.newMessageFromUser,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.notificationsRestrictions.newMessageFromUser = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.newMessageFromUser]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_40, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.new-receipt')), 1),
                _createVNode("div", _hoisted_41, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_42, [
                        (_ctx.notificationsRestrictions.createReciept)
                          ? (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.createReciept,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.notificationsRestrictions.createReciept = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.createReciept]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.new-invoice')), 1),
                _createVNode("div", _hoisted_46, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_47, [
                        (_ctx.notificationsRestrictions.createInvoice)
                          ? (_openBlock(), _createBlock("span", _hoisted_48, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.createInvoice,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.notificationsRestrictions.createInvoice = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.createInvoice]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_50, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.new-invoice-receipt')), 1),
                _createVNode("div", _hoisted_51, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_52, [
                        (_ctx.notificationsRestrictions.createInvoiceReceipt)
                          ? (_openBlock(), _createBlock("span", _hoisted_53, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.createInvoiceReceipt,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.notificationsRestrictions.createInvoiceReceipt = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.createInvoiceReceipt]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_55, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.basic-notifications.order-changed')), 1),
                _createVNode("div", _hoisted_56, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_57, [
                        (_ctx.notificationsRestrictions.orderChanged)
                          ? (_openBlock(), _createBlock("span", _hoisted_58, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.orderChanged,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.notificationsRestrictions.orderChanged = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.orderChanged]
                      ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_60, [
        _createVNode("div", _hoisted_61, [
          _createVNode("h5", _hoisted_62, [
            _createVNode("button", _hoisted_63, _toDisplayString(_ctx.$t('provider.notifications-restrictions.unfinished-products-notifications-group-title')), 1)
          ]),
          _createVNode("div", _hoisted_64, [
            (_ctx.editMode === false)
              ? (_openBlock(), _createBlock("h5", _hoisted_65, [
                  (_ctx.unfinishedProductsNotificationsToggle)
                    ? (_openBlock(), _createBlock("span", _hoisted_66, _toDisplayString(_ctx.$t('label.active')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_67, _toDisplayString(_ctx.$t('label.notactive')), 1))
                ]))
              : _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.activateDeactivateGroupNotifications(2, !_ctx.unfinishedProductsNotificationsToggle)), ["stop"])),
                  type: "checkbox",
                  class: "toggle",
                  checked: _ctx.unfinishedProductsNotificationsToggle,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.unfinishedProductsNotificationsToggle = $event))
                }, null, 8, ["checked"])), [
                  [_vModelCheckbox, _ctx.unfinishedProductsNotificationsToggle]
                ])
          ]),
          _hoisted_68
        ]),
        _createVNode("div", _hoisted_69, [
          _createVNode("div", _hoisted_70, [
            _createVNode("div", _hoisted_71, [
              _createVNode("div", _hoisted_72, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-no-slots')), 1),
                _createVNode("div", _hoisted_73, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_74, [
                        (_ctx.notificationsRestrictions.unfinishedProductSlotEmpty)
                          ? (_openBlock(), _createBlock("span", _hoisted_75, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_76, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductSlotEmpty,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductSlotEmpty = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductSlotEmpty]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_77, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-no-prices')), 1),
                _createVNode("div", _hoisted_78, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_79, [
                        (_ctx.notificationsRestrictions.unfinishedProductPriceEmpty)
                          ? (_openBlock(), _createBlock("span", _hoisted_80, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_81, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductPriceEmpty,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductPriceEmpty = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductPriceEmpty]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_82, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-slots-less-30')), 1),
                _createVNode("div", _hoisted_83, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_84, [
                        (_ctx.notificationsRestrictions.unfinishedProductSlotLess)
                          ? (_openBlock(), _createBlock("span", _hoisted_85, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_86, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductSlotLess,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductSlotLess = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductSlotLess]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_87, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-prices-less-30')), 1),
                _createVNode("div", _hoisted_88, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_89, [
                        (_ctx.notificationsRestrictions.unfinishedProductPriceLess)
                          ? (_openBlock(), _createBlock("span", _hoisted_90, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_91, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductPriceLess,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductPriceLess = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductPriceLess]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_92, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-no-photos')), 1),
                _createVNode("div", _hoisted_93, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_94, [
                        (_ctx.notificationsRestrictions.unfinishedProductNoPhoto)
                          ? (_openBlock(), _createBlock("span", _hoisted_95, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_96, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductNoPhoto,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductNoPhoto = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductNoPhoto]
                      ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_97, [
        _createVNode("div", _hoisted_98, [
          _createVNode("h5", _hoisted_99, [
            _createVNode("button", _hoisted_100, _toDisplayString(_ctx.$t('provider.notifications-restrictions.about-upcoming-orders-notifications-group-title')), 1)
          ]),
          _createVNode("div", _hoisted_101, [
            (_ctx.editMode === false)
              ? (_openBlock(), _createBlock("h5", _hoisted_102, [
                  (_ctx.aboutUpcomingOrdersNotificationsToggle)
                    ? (_openBlock(), _createBlock("span", _hoisted_103, _toDisplayString(_ctx.$t('label.active')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_104, _toDisplayString(_ctx.$t('label.notactive')), 1))
                ]))
              : _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.activateDeactivateGroupNotifications(3, !_ctx.aboutUpcomingOrdersNotificationsToggle)), ["stop"])),
                  type: "checkbox",
                  class: "toggle",
                  checked: _ctx.aboutUpcomingOrdersNotificationsToggle,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.aboutUpcomingOrdersNotificationsToggle = $event))
                }, null, 8, ["checked"])), [
                  [_vModelCheckbox, _ctx.aboutUpcomingOrdersNotificationsToggle]
                ])
          ]),
          _hoisted_105
        ]),
        _createVNode("div", _hoisted_106, [
          _createVNode("div", _hoisted_107, [
            _createVNode("div", _hoisted_108, [
              _createVNode("div", _hoisted_109, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.about-upcoming-orders-notifications.before-two-days')), 1),
                _createVNode("div", _hoisted_110, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_111, [
                        (_ctx.notificationsRestrictions.sendUpcomingOrdersBeforeTwoDays)
                          ? (_openBlock(), _createBlock("span", _hoisted_112, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_113, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.sendUpcomingOrdersBeforeTwoDays,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.notificationsRestrictions.sendUpcomingOrdersBeforeTwoDays = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.sendUpcomingOrdersBeforeTwoDays]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_114, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.about-upcoming-orders-notifications.today')), 1),
                _createVNode("div", _hoisted_115, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_116, [
                        (_ctx.notificationsRestrictions.sendUpcomingOrdersToday)
                          ? (_openBlock(), _createBlock("span", _hoisted_117, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_118, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.sendUpcomingOrdersToday,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.notificationsRestrictions.sendUpcomingOrdersToday = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.sendUpcomingOrdersToday]
                      ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_119, [
        _createVNode("div", _hoisted_120, [
          _createVNode("h5", _hoisted_121, [
            _createVNode("button", _hoisted_122, _toDisplayString(_ctx.$t('provider.notifications-restrictions.product-is-live-group-title')), 1)
          ]),
          _createVNode("div", _hoisted_123, [
            (_ctx.editMode === false)
              ? (_openBlock(), _createBlock("h5", _hoisted_124, [
                  (_ctx.productBecameLiveNotificationsToggle)
                    ? (_openBlock(), _createBlock("span", _hoisted_125, _toDisplayString(_ctx.$t('label.active')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_126, _toDisplayString(_ctx.$t('label.notactive')), 1))
                ]))
              : _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (_ctx.activateDeactivateGroupNotifications(4, !_ctx.productBecameLiveNotificationsToggle)), ["stop"])),
                  type: "checkbox",
                  class: "toggle",
                  checked: _ctx.productBecameLiveNotificationsToggle,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.productBecameLiveNotificationsToggle = $event))
                }, null, 8, ["checked"])), [
                  [_vModelCheckbox, _ctx.productBecameLiveNotificationsToggle]
                ])
          ]),
          _hoisted_127
        ]),
        _createVNode("div", _hoisted_128, [
          _createVNode("div", _hoisted_129, [
            _createVNode("div", _hoisted_130, [
              _createVNode("div", _hoisted_131, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.product-is-live.product-became-live')), 1),
                _createVNode("div", _hoisted_132, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_133, [
                        (_ctx.notificationsRestrictions.productOnAir)
                          ? (_openBlock(), _createBlock("span", _hoisted_134, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_135, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.productOnAir,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.notificationsRestrictions.productOnAir = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.productOnAir]
                      ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})